module.exports = __webpack_public_path__ + "static/mobile-packages-hero-c03aca5b3328685b43c7e7414918fd5d.jpg";